import {React, clickOn, _n, _s} from 'pexui';
import {startBusy,stopBusy} from './busy';

export const NavButton = ({id, className, style, label, onClick}) => (
    <div id={id}
        className={className || "infw-btn-secondary"}
        style={style}
        onClick={onClick}>
        {label}
        <span className="infw-icon-right"
            style={{float: "right"}}/>
    </div>
)

export const Button = ({id, className, style, label, name, activeWhenBusy, busyZone, disabled, onClick}) => {
    const theButton = <button
        id={id}
        className={className || "infw-btn-secodary"}
        style={style}
        name={name}
        disabled={disabled}
        data-activeWhenBusy={activeWhenBusy} // used by busy blocking
        data-busyZone={busyZone}
        onClick={busyZone?
            (evt)=>{
                startBusy(theButton);

                if(typeof onClick === 'function'){
                    onClick(evt);
                }
            }: onClick}
        >{label}</button>;
    return theButton;
}

export const RadioButon = ({id, className, style, label, name, value, checked, onClick}) => (
    <div className={className} style={style}>
        <input id={id}
            type="radio"
            name={name}
            value={value}
            checked={checked || undefined}
            onClick={onClick}
        />
        <span>{label}</span>
    </div>
    )

export const Link = ({id, className, style, label, icon, activeWhenBusy, busyZone, onClick}) => {
    const theLink = <a 
        id={id} 
        className={className}
        style={style}
        data-activeWhenBusy={activeWhenBusy} // used by busy blocking
        data-busyZone={busyZone}    
        onClick={evt=>{
            evt.preventDefault();
            if(busyZone){
                startBusy(theLink);
            }
            if(typeof onClick==='function'){
                onClick(evt);
            }
        }}>
        {icon?<span className={icon}/>:''}
        {label}
    </a>;
    return theLink;
}

export const RemoveButton = ({label, icon, busyZone, onClick}) => {
    const theRemoveButton = <div 
        style={'cursor:pointer;color:#1274b8'}
        data-busyZone={busyZone} 
        tabIndex={0}
        onKeyDown={(evt) => {
            if (evt.keyCode === 32) {
                evt.preventDefault();
                if(busyZone){
                    startBusy(theRemoveButton);
                }
                if(typeof onClick==='function'){
                    onClick(evt);
                }
            }
        }}   
        onClick={evt=>{
            evt.preventDefault();
            if(busyZone){
                startBusy(theRemoveButton);
            }
            if(typeof onClick==='function'){
                onClick(evt);
            }
        }}>
        {icon?<span className={icon}/>:''}
        {label}
    </div>;
    return theRemoveButton;
}



// WEBPACK FOOTER //
// ./application/src/views/comps/uicomps.jsx